import { observer } from 'mobx-react-lite'
import { useStores } from 'models/root-store'
import React from 'react'
import LiveDetailPage from './page'
import { useHistory, useParams } from 'react-router-dom'

interface RouteParams {
  liveId: string
}

const EditLinkPageContainer = observer(() => {
  const { liveId } = useParams<RouteParams>()

  const history = useHistory()

  const {
    livesStore: { getLiveById, status },
  } = useStores()

  return (
    <LiveDetailPage
      live={getLiveById(liveId)}
      status={status}
      navigateToHomePage={() => history.push('/')}
    />
  )
})

export default EditLinkPageContainer
